import React, { useEffect, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from 'react-redux';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Layout from './components/layout/Main';
import { DashboardDataProvider } from "./components/context/dashboardDataContext";
import SimActivation from './pages/activations/SimActivation';
import BulkActivation from './pages/activations/BulkActivation';
import PurchaseSim from './pages/inventory/PurchaseSim';
import PurchaseSimList from './pages/inventory/PurchaseSimList';
import InventoryTransfer from './pages/inventory/InventoryTransfer';
import { AlertContainer } from './components/utils/ToastAlert';
import SimList from './pages/inventory/SimList';
import SingleRecharge from './pages/recharge/SingleRecharge';
import BulkRecharge from './pages/recharge/BulkRecharge';
import ActivationReport from './pages/reports/ActivationReport';
import RechargeReport from './pages/reports/RechargeReport';
import BatchActivationReport from './pages/reports/BatchActivationReport';
import BatchRechargeReport from './pages/reports/BatchRechargeReport';
import MDNSwapReport from './pages/reports/MDNSwapReport';
import SIMSwapReport from './pages/reports/SIMSwapReport';
import WIFIBatchReport from './pages/reports/WIFIBatchReport';
import MDNSwap from './pages/swap/MDNSwap';
import SIMSwap from './pages/swap/SIMSwap';
import CancelWiFi from './pages/wifi/CancelWiFi';
import WiFiActivation from './pages/wifi/WiFiActivation';
import CheckStatus from './pages/checkstatus/CheckStatus';
import PortinCheckStatus from './pages/checkstatus/PortinCheckStatus';
import PageNotFound from './pages/PageNotFound';
import Dealer from './pages/admin/Dealer';
import User from './pages/admin/User';
import LedgerReport from './pages/reports/LedgerReport';
import PageAccess from './pages/admin/PageAccess';
import genericActions from "./redux/generic/actions";
import authactions from "./redux/auth/actions";
import PlanPriceMapping from './pages/admin/PlanPriceMapping';
import FundManagement from './pages/admin/FundManagement';
import { isAdmin, isDealer, isDealerUser } from './helpers/commonFunction';
import FundManagementReport from './pages/reports/FundManagementReport';
// import ReactivationReport from './pages/reports/ReactivationReport';

const { getUserPanelAccess } = genericActions;
const { getUserDataByToken } = authactions;



const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center">
    <div className="text-center">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading....</span>
      </div>
    </div>
  </div>
);


function App() {
  const dispatch = useDispatch();
  const { UserPanelAccessList } = useSelector(state => state.generic);
  const { tokenData } = useSelector((state) => state.auth);

  const isAuthenticated = () => {
    let token = localStorage.getItem("colt_wireless_token");
    if (token) {
      let decodedToken = jwtDecode(token);
      let currentDate = new Date();
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        localStorage.removeItem("colt_wireless_token");
        return false;
      }
      else {
        return true;
      }
    } else {
      localStorage.removeItem("colt_wireless_token");
      return false;
    }
  }


  useEffect(() => {
    dispatch(getUserDataByToken());
  }, []);

  useEffect(() => {
    if (tokenData?.distributorID) {
      dispatch(getUserPanelAccess({ distributorId: Number(tokenData?.distributorID) }))
    }
  }, [tokenData])

  const accessMenuFun = (id) => {
    return (
      Array.isArray(UserPanelAccessList) &&
      UserPanelAccessList.some((item) => item?.ID == id && item?.STATUS));
  };


  return (
    <div className="admin-container position-relative overflow-hidden">
      <DashboardDataProvider>
        <AlertContainer />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/login" element={isAuthenticated() ? <Navigate to="/" replace /> : <Login />} />
            <Route path='*' element={isAuthenticated() ? <PageNotFound /> : <Navigate to="/login" />} />
            <Route path="/" element={!isAuthenticated() ? <Navigate to="/login" /> : <Layout />} >
              {<Route path="/" element={<Dashboard />} />}
              {isAdmin(tokenData) && <Route path="/admin/dealer" element={<Dealer />} />}
              {(isAdmin(tokenData) || (accessMenuFun(1) && (isDealer(tokenData) || isDealerUser(tokenData)))) && <Route path="/admin/user" element={<User />} />}
              {isAdmin(tokenData) && <Route path="/admin/page-access" element={<PageAccess />} />}
              {isAdmin(tokenData) && <Route path="/admin/plan-price-mapping" element={<PlanPriceMapping />} />}
              {isAdmin(tokenData) && <Route path="/admin/fund-management" element={<FundManagement />} />}
              {isAdmin(tokenData) && <Route path="/inventory/purchase-sim" element={<PurchaseSim />} />}
              {(isAdmin(tokenData) || (accessMenuFun(20) && (isDealer(tokenData) || isDealerUser(tokenData)))) && <Route path="/inventory/inventory-transfer" element={<InventoryTransfer />} />}
              {(isAdmin(tokenData) || (accessMenuFun(2) && (isDealer(tokenData) || isDealerUser(tokenData)))) && <Route path="/inventory/sim-list" element={<SimList />} />}
              {isAdmin(tokenData) && <Route path="/inventory/purchase-sim-list" element={<PurchaseSimList />} />}
              {(isAdmin(tokenData) || (accessMenuFun(3) && (isDealer(tokenData) || isDealerUser(tokenData)))) && <Route path="/activation/sim-activation" element={<SimActivation />} />}
              {(isAdmin(tokenData) || (accessMenuFun(4) && (isDealer(tokenData) || isDealerUser(tokenData)))) && <Route path="/activation/bulk-activation" element={<BulkActivation />} />}
              {(isAdmin(tokenData) || (accessMenuFun(5) && (isDealer(tokenData) || isDealerUser(tokenData)))) && <Route path="/recharge/single-recharge" element={<SingleRecharge />} />}
              {(isAdmin(tokenData) || (accessMenuFun(6) && (isDealer(tokenData) || isDealerUser(tokenData)))) && <Route path='/recharge/bulk-recharge' element={<BulkRecharge />} />}
              {accessMenuFun(7) && <Route path="/reports/activation-report" element={<ActivationReport />} />}
              {accessMenuFun(8) && <Route path='/reports/recharge-report' element={<RechargeReport />} />}
              {accessMenuFun(9) && <Route path='/reports/msisdn-swap-report' element={<MDNSwapReport />} />}
              {accessMenuFun(10) && <Route path='/reports/sim-swap-report' element={<SIMSwapReport />} />}
              {accessMenuFun(11) && <Route path='/reports/batch-activation-report' element={<BatchActivationReport />} />}
              {accessMenuFun(12) && <Route path='/reports/batch-recharge-report' element={<BatchRechargeReport />} />}
              {accessMenuFun(13) && <Route path='/reports/wifi-batch-report' element={<WIFIBatchReport />} />}
              {accessMenuFun(14) && <Route path='/reports/ledger-report' element={<LedgerReport />} />}
              {accessMenuFun(15) && <Route path='/wifi/wifi-activation' element={<WiFiActivation />} />}
              {accessMenuFun(16) && <Route path='/wifi/cancel-wifi' element={<CancelWiFi />} />}
              {/* {accessMenuFun(17) && <Route path='/swap/mdn-swap' element={<MDNSwap />} />} */}
              {accessMenuFun(18) && <Route path='/swap/sim-swap' element={<SIMSwap />} />}
              {accessMenuFun(19) && <Route path='/checkStatus/check-status' element={<CheckStatus />} />}
                 {/* {accessMenuFun(20) && <Route path='/reports/reactivation-report' element={<ReactivationReport />} />} */}
              {isAdmin(tokenData) && <Route path='/reports/fund-report' element={<FundManagementReport />} />}
              {/* {accessMenuFun('') && <Route path='/checkStatus/portin-check-status' element={<PortinCheckStatus />} />} */}

            </Route>
          </Routes>
        </Suspense>
      </DashboardDataProvider>
    </div>
  );
}

export default App;